import Vue from 'vue'
import VueI18n from 'vue-i18n'

import es from './es'
import en from './en'
import pt from './pt'

Vue.use(VueI18n)

const euroFormat = {
  currency: {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'code'
  },
  currency8: {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 8,
    maximumFractionDigits: 8
  },
  decimal8: {
    style: 'decimal',
    currency: 'EUR',
    minimumFractionDigits: 8,
    maximumFractionDigits: 8
  }
}

const numberFormats = {
  'es': euroFormat,
  'en': euroFormat,
  'pt': euroFormat
}

const language = function() {
  const supported = ['es', 'en', 'pt']

  let lRegExp = /^([a-z]{2})(?:[-_].*)?$/g

  const match = lRegExp.exec(navigatorLanguage())
  const locale = match ? match[1] : 'en'
  console.log('Locale is: ' + locale)
  return supported.includes(locale) ? locale : 'en'
}

const navigatorLanguage = function() {
  return navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: language(), // set locale based on navigator
  fallbackLocale: 'en', // set fallback locale
  messages: {
    es,
    en,
    pt
  },
  numberFormats
})

export default i18n
